import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';
import { SalesProofImage } from './SalesProofImage';

export const SalesProofViewer = ({ proof, onClose, returnFocusRef }) => (
  <Dialog open={Boolean(proof)} onOpenChange={(open) => { if (!open) onClose(); }}>
    {proof && (
      <DialogContent
        className="w-[calc(100%-2rem)] max-w-5xl max-h-[90dvh] overflow-y-auto rounded-lg p-4 sm:p-6"
        data-testid="salesproof-viewer"
        closeButtonTestId="salesproof-viewer-close"
        onCloseAutoFocus={(event) => {
          event.preventDefault();
          returnFocusRef.current?.focus();
        }}
      >
        <DialogTitle className="pr-8 text-base md:text-lg leading-snug tracking-normal text-[#0D234E]" data-testid="salesproof-viewer-title">{proof.title}</DialogTitle>
        <div className="min-w-0 bg-gray-50 rounded-md">
          <SalesProofImage key={proof.id} proof={proof} testId="salesproof-viewer-image" className="block w-full max-h-[60dvh] object-contain" />
        </div>
        <DialogDescription className="text-sm leading-relaxed text-gray-700" data-testid="salesproof-viewer-description">{proof.description}</DialogDescription>
        <a
          href={proof.image_url}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex w-fit items-center gap-2 text-sm font-semibold text-[#0D234E] hover:underline"
          data-testid="salesproof-viewer-original-link"
        >
          Open original image <ExternalLink size={16} aria-hidden="true" />
        </a>
      </DialogContent>
    )}
  </Dialog>
);